<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M55 13.09a13.82 13.82 0 00-19.52 0L32 16.53l-3.44-3.44A13.8 13.8 0 109.05 32.62L30.6 53.73a2 2 0 002.8 0L55 32.61a13.82 13.82 0 000-19.52zm-2.15 17.39L32 50.9 11.16 30.49a10.8 10.8 0 0115.28-15.28L32 20.77l5.56-5.56a10.8 10.8 0 0115.29 15.27z"/></svg>